export const MODELS = {
  fast: 'claude-haiku-4-5-20251001',
  balanced: 'claude-sonnet-4-6',
  premium: 'claude-opus-4-6',
};

const TIER_FROM_STRING = {
  'claude-haiku-4-5-20251001': 'fast',
  'claude-sonnet-4-6': 'balanced',
  'claude-opus-4-6': 'premium',
};

function normalizeTier(value) {
  if (['fast', 'balanced', 'premium'].includes(value)) return value;
  if (TIER_FROM_STRING[value]) return TIER_FROM_STRING[value];
  return 'fast';
}

const DEFAULTS = {
  'wanderologie_settings.photoAIFilter': true,
  'wanderologie_settings.photoAIModel': MODELS.fast,
  'wanderologie_settings.aiModel': 'fast',
  'wanderologie_settings.currency': 'USD',
  'wanderologie_settings.units': 'metric',
  'wanderologie_settings.colorScheme': 'default',
  'wanderologie_settings.extendedCaching': false,
  'wanderologie_settings.showAvantLeDepart': true,
  'wanderologie_settings.avantScope': 'all',
  'wanderologie_settings.showBookingInfo': true,
  'wanderologie_settings.showCostEstimates': true,
  'wanderologie_settings.showLocation': true,
};

export const MODEL_TIMEOUTS = {
  fast: { api: 60000, skeleton: 30000 },      // Haiku: 60s proxy, 30s skeleton
  balanced: { api: 75000, skeleton: 45000 },   // Sonnet: 75s proxy, 45s skeleton
  premium: { api: 120000, skeleton: 90000 },   // Opus: 120s proxy, 90s skeleton
};

export function getModelTimeout(type = 'api') {
  const tier = getSetting('wanderologie_settings.aiModel') || 'fast';
  return MODEL_TIMEOUTS[tier]?.[type] || MODEL_TIMEOUTS.fast[type];
}

export function getSetting(key) {
  try {
    const raw = localStorage.getItem(key);
    if (raw === null) {
      const def = DEFAULTS[key] ?? null;
      return key === 'wanderologie_settings.aiModel' && def ? normalizeTier(def) : def;
    }
    if (raw === 'true') return true;
    if (raw === 'false') return false;
    if (key === 'wanderologie_settings.aiModel') return normalizeTier(raw);
    return raw;
  } catch { return DEFAULTS[key] ?? null; }
}

export function setSetting(key, value) {
  try {
    localStorage.setItem(key, String(value));
  } catch { /* storage full or private mode — fail silently */ }
}

